import { CardView } from "../../../components/folders/CardView.tsx";
import { useParams } from "react-router-dom";
import { fetchAllUsers } from "../../../redux/actions/usersActions.tsx";
import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks.ts";

export default function FolderIdPage() {
  const params = useParams();
  const dispatch = useAppDispatch();

  const { userInfo } = useAppSelector((state) => state.auth);
  const isAdmin = userInfo?.groups.includes("admin");

  const onFetchUsers = async () => {
    if (!isAdmin) return;

    await dispatch(fetchAllUsers("/accounts/users/?limit=1000"));
  };

  useEffect(() => {
    onFetchUsers();
  }, [isAdmin]);

  return (
    <div className="w-full h-full p-8">
      <CardView folderId={params.id!} />
    </div>
  );
}
